import { Note } from "../types";
import cardStyles from "../styles/Card.module.css";

export function NoteComponent(note:Note)
{
    function formatCreatedTime() {
        const created = note.created.toString().split('T')
        return created[0] + ' ' + created[1].split('.')[0]
    }

    return(<div className={cardStyles.card}>
        <b>{note.createdByUser}</b> [{formatCreatedTime()}]: {note.text}
    </div>)
}
